import { render, staticRenderFns } from "./TypeAnalisisLabel.vue?vue&type=template&id=a24a1a26"
import script from "./TypeAnalisisLabel.vue?vue&type=script&lang=js"
export * from "./TypeAnalisisLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports